import React, { useEffect, useState } from 'react';
import T from 'prop-types';
// components
import { FormattedMessage, useIntl } from 'react-intl';
import NameTokenInput, { NAME_TOKEN } from 'components/NameTokenInput';
import Button from 'components/Button';
// utils
import classnames from 'classnames/bind';
// styles
import styles from './QuickReplyTemplateSetting.module.scss';

const cn = classnames.bind(styles);

// Mirrors Farmfeed::QuickReply#render on the backend: a blank name drops the token with its comma
export const renderQuickReply = (template, name) => {
  if (name) return template.split(NAME_TOKEN).join(name);
  return template.replace(/,?\s*\{name\}/g, '').replace(/\s+/g, ' ').trim();
};

// Phrasing with a "first name" pill, saved on demand like the profile name fields
const QuickReplyTemplateSetting = ({ className, value, previewName, isDisabled, onSave }) => {
  const { formatMessage } = useIntl();
  const [template, setTemplate] = useState(value);
  const trimmed = template.trim();
  const hasChanged = trimmed !== value;

  useEffect(() => {
    setTemplate(value);
  }, [value]);

  const handleSave = () => {
    if (!hasChanged || isDisabled) return;
    onSave(trimmed);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSave();
    }
  };

  return (
    <div className={cn('quick-reply-template', { [className]: !!className })}>
      <div className={cn('text')}>
        <FormattedMessage id="container.myProfile.farmfeed.quickReply" />
      </div>
      <div className={cn('description')}>
        <FormattedMessage id="container.myProfile.farmfeed.quickReply.description" />
      </div>
      <div className={cn('input')} onKeyPress={handleKeyPress}>
        <NameTokenInput
          value={template}
          onChange={setTemplate}
          disabled={isDisabled}
          maxLength={200}
          tokenLabel={formatMessage({ id: 'container.myProfile.farmfeed.quickReply.nameToken' })}
          addLabel={formatMessage({ id: 'container.myProfile.farmfeed.quickReply.addName' })}
          placeholder={formatMessage({ id: 'container.myProfile.farmfeed.quickReply.placeholder' })}
        />
      </div>
      <div className={cn('preview')}>
        <FormattedMessage
          id="container.myProfile.farmfeed.quickReply.preview"
          values={{ text: renderQuickReply(trimmed, previewName) }}
        />
      </div>
      <Button primary small onClick={handleSave} disabled={isDisabled || !hasChanged}>
        <FormattedMessage id="general.button.saveChanges" />
      </Button>
    </div>
  );
};

QuickReplyTemplateSetting.propTypes = {
  className: T.string,
  value: T.string.isRequired,
  previewName: T.string,
  isDisabled: T.bool,
  onSave: T.func.isRequired,
};

QuickReplyTemplateSetting.defaultProps = {
  className: '',
  previewName: 'Blake',
  isDisabled: false,
};

export default QuickReplyTemplateSetting;
